import { Outlet } from "react-router-dom";
import { PermissionList } from "./PermissionList";
import PermissionForm from "./PermissionForm";

export const permissionsRoutes = [
  {
    path: "permissions",
    element: Outlet,
    children: [
      {
        path: "",
        element: PermissionList,
      },
      {
        path: "add",
        element: PermissionForm,
      },
      {
        path: "edit/:id",
        element: PermissionForm,
      },
    ],
  },
];
